<ng-container *ngIf="!errorType">
  <div *ngIf="!loaded" class="loader">
    <loader-overlay
      [darkOnly]="previewMode === 'popup'"
      [styles]="{ backgroundColor: 'transparent', backdropFilter: 'none' }"
    >
    </loader-overlay>
  </div>
  <video
    #mediaRef
    *ngIf="srcUrl"
    [src]="srcUrl | safe: 'resource'"
    [attr.loaded]="!!loaded"
    [attr.is-audio]="isAudio"
    [controls]="allowControls || isAudio"
    playsinline
  >
    Sorry, but your browser doesn't support video
  </video>
  <div *ngIf="loaded && !isPopup && !isAudio" class="play-btn-wrapper">
    <div class="play-btn"></div>
  </div>
</ng-container>

<ng-container *ngIf="errorType">
  <error-preview
    [errorType]="errorType"
    [previewMode]="previewMode"
    [icon]="model.icon"
    (reload)="reload.emit()"
    (download)="download.emit()"
    (open)="open.emit()"
  >
  </error-preview>
</ng-container>
